<template>
  <div class="setup-billing">
    <h1>How often should we stop by?</h1>
    <p>Lets decide how frequently we treat for your year round pest service!</p><br>
     <v-card class="tabs-wrapper">
      <v-overlay :model-value="loading" persistent class="d-flex align-center justify-center">
        <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
      </v-overlay>
      <!--<v-parallax src="https://cdn-ffifb.nitrocdn.com/WRggslnCBWFrLhRGAFRaOZCBdKaqeZcu/assets/images/optimized/rev-663916c/missionpestcontrol.com/wp-content/uploads/2022/02/Asset-28Services.jpg">-->
      <v-tabs v-model="tab" align-tabs="center" color="primary">
        <v-tab v-for="(freq, index) in frequencies" :key="index" :value="index + 1">
          {{ freq.label }}
        </v-tab>
      </v-tabs>

      <v-tabs-window v-model="tab">
        <v-tabs-window-item
          v-for="(freq, index) in frequencies"
          :key="index"
          :value="index + 1"
          class="tab-content"
        >
          <v-container fluid>
            <div class="d-flex align-center justify-center" style="height: 100%; width: 100%;">
              <v-icon style="font-size: 10rem;" color="primary" class="mr-4">
                {{ freq.icon }}
              </v-icon>
              <h3 class="mb-0 desc">{{ freq.desc }}</h3>
            </div>
            <v-row class="center text-center">
              <v-col cols="12" sm="4">
                <v-sheet class="ma-2 pa-2 text-overline">
                  <span>Initial Treatment</span>
                  <h1><span style="text-decoration: line-through;">$249</span> ${{ freq.initialCharge }}</h1>
                </v-sheet>
              </v-col>
              <v-col cols="12" sm="4">
                <v-sheet class="ma-2 pa-2 text-overline">
                  <span>Every Treatment</span>
                  <h1>${{ freq.serviceCharge }}</h1>
                </v-sheet>
              </v-col>
              <v-col cols="12" sm="4">
                <v-sheet class="ma-2 pa-2 text-overline">
                  <span>Treatments per year</span>
                  <h1>{{ freq.treatmentsPerYear }}</h1>
                </v-sheet>
              </v-col>
            </v-row>
          </v-container>

          <p class="ml-4 mr-4">Quarterly pest control is the minimum recommendation to keep most homes pest-free. In some cases—like severe infestations, persistent pests, or warm and wet climates—more frequent visits are needed.</p>

          <br/>
          <v-card-text>
            <v-row>
              <v-col>
              <v-form v-model="valid" @submit.prevent="submitPayment">
                <v-text-field
                  v-model="cardNumber"
                  label="Card Number"
                  placeholder="1234567812345678"
                  variant="outlined"
                  :rules="rules.cardNumber"
                />
                <v-text-field
                  v-model="expiry"
                  label="Expiration Date (MMYY)"
                  placeholder="MMYY"
                  variant="outlined"
                  :rules="rules.expiry"
                  @input="expiry = expiry.replace(/[^0-9]/g, '')"
                />
                <v-text-field
                  v-model="cvc"
                  label="CVC"
                  placeholder="123"
                  variant="outlined"
                  :rules="rules.cvc"
                />
                <v-btn
                  :disabled="!valid || loading"
                  type="submit"
                  color="primary"
                  size="large"
                  class="font-weight-bold"
                >
                  Lets Get Started!
                </v-btn>
              </v-form>
              <p v-if="error" class="error">{{ error }}</p>
              <p v-if="success" class="success">{{ success }}</p>
              </v-col>
              <v-col>
                <b>Service Address:</b><br/>
                {{ customer.address }} {{ customer.city }} {{ customer.zip }}
                <br/><br/>
                <b>First Appointment:</b><br/>
                {{ appointment.date }}
              </v-col>
            </v-row>
          </v-card-text>
        </v-tabs-window-item>
      </v-tabs-window>
      <!--</v-parallax>-->
    </v-card>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "SetupBilling",
  data() {
    return {
      loading: false,
      address: JSON.parse(localStorage.getItem("mission-place")) || null,
      customer: JSON.parse(localStorage.getItem("mission-customer")) || null,
      appointment: JSON.parse(localStorage.getItem("mission-appointment")) || null,
      cardNumber: "", // Credit card number
      expiry: "", // Expiry date MMYY
      cvc: "", // Card security code
      valid: false,
      success: null, // Success message
      error: null, // Error message
      frequency: 0,
      tab: 1,
      subscription: {
        success: false,
        id: null,
      },
      apiBaseUrl: process.env.NODE_ENV === 'development'
        ? 'http://localhost:3000/api'  // Local server
        : 'https://api.getpestcontrol.services/api',  // Production server
      rules: {
        cardNumber: [
          v => !!v || 'Card number is required.',
          v => /^\d{15,16}$/.test(v) || 'Card number must be 15 or 16 digits.'
        ],
        expiry: [
          v => !!v || 'Expiration date is required.',
          v => /^\d{4}$/.test(v) || 'Expiration must be in MMYY format.',
          v => {
            const now = new Date();
            const inputMonth = parseInt(v.substring(0, 2));
            const inputYear = parseInt('20' + v.substring(2, 4));
            if (isNaN(inputMonth) || inputMonth < 1 || inputMonth > 12) return 'Invalid month.';
            const expiryDate = new Date(inputYear, inputMonth);
            return expiryDate > now ? true : 'Card has expired.';
          }
        ],
        cvc: [
          v => !!v || 'CVC is required.',
          v => /^\d{3,4}$/.test(v) || 'CVC must be 3 or 4 digits.'
        ]
      },
      frequencies: [
        {
          label: "Quarterly",
          icon: "mdi-trending-up",
          desc: "Most Popular",
          service: 2663,
          initialCharge: 169,
          serviceCharge: 169,
          treatmentsPerYear: 4
        },
        {
          label: "Bi-Monthly",
          icon: "mdi-shield-star-outline",
          desc: "Most Recommended",
          service: 2998,
          initialCharge: 99,
          serviceCharge: 169,
          treatmentsPerYear: 6
        },
        {
          label: "Monthly",
          icon: "mdi-shield-bug",
          desc: "Best Protection",
          service: 2677,
          initialCharge: 1,
          serviceCharge: 169,
          treatmentsPerYear: 12
        }
      ],
    };
  },
  methods: {
    async submitPayment() {
      this.loading = true;
      const selectedFrequency = this.frequencies[this.tab - 1];
      const methodCode = this.getCardMethod(this.cardNumber);
      console.log("method code: ", methodCode);

      if (!methodCode) {
        this.error = 'Unsupported card type.';
        this.loading = false;
        return;
      }
      try {
        // save billing
        const responsePayment = await axios.post(`${this.apiBaseUrl}/customer/payment`,
          {
            customer: this.customer.customerID,
            fname: this.customer.fname,
            lname: this.customer.lname,
            email: this.customer.email,
            phone1: this.customer.phone1,
            address: this.customer.address,
            city: this.customer.city,
            state: this.customer.state,
            zip: this.customer.zip,
            method: methodCode,
            number: this.cardNumber,
            cvv: this.cvc, // server is expecting cvv
            expiration: this.expiry,
            service: selectedFrequency.service,
            initialCharge: selectedFrequency.initialCharge,
            serviceCharge: selectedFrequency.serviceCharge,
            appointmentDate: this.appointment?.date,
            appointmentTime: this.appointment?.chosenTime,
            appointmentStart: this.appointment?.start,
            appointmentEnd: this.appointment?.end,
            routeID: this.appointment?.routeID,
          }
        );

        // save appointment
        if (responsePayment.data.success) {
          // set subscription info
          this.subscription.success = responsePayment.data.success;
          this.subscription.id = responsePayment.data.result;
          // make sure the appointment is associated with the new subscription
          this.appointment.subscriptionID = this.subscription.id;
          // create appointment
          const responseAppointment = await axios.post(`${this.apiBaseUrl}/appointment/create`, this.appointment);
          if(process.env.NODE_ENV === 'development') { console.log(responseAppointment.data); }
          if (responseAppointment.data.success) {
            localStorage.setItem('mission-billing', JSON.stringify(this.subscription));
            this.$emit('send-billing', this.subscription);
          } else {
          // TODO: we need to handle error cases with a banner atleast
          }
        }

        this.success = "Payment info saved successfully!";
        this.error = null;
        console.log("FieldRoutes Response:", responsePayment.data);
      } catch (err) {
        this.error = err.message;
        this.success = null;
        console.error("Error saving payment info:", err);
      } finally {
        this.loading = false;
      }
    },
    getCardMethod(cardNumber) {
      if (/^4/.test(cardNumber)) return 2; // Visa
      if (/^5[1-5]/.test(cardNumber) || /^2(2[2-9][1-9]|[3-6]\d{2}|7[01]\d|720)/.test(cardNumber)) return 3; // Mastercard
      if (/^3[47]/.test(cardNumber)) return 1; // Amex
      if (/^6(?:011|5|22)/.test(cardNumber)) return 5; // Discover
      return null; // Unknown
    }
  },
};
</script>

<style scoped>
.error {
  color: red;
}
.desc {
  color: var(--brand-primary);
  font-style: italic;
  font-weight: var(--font-weight-bold);
}
.success {
  color: green;
}
.v-parallax img {
  opacity: 0.5;
}
button.v-tab {
  font-size: large;
}
.tabs-wrapper {
  min-height: 100vh; /* Make the wrapper full viewport height */
  display: flex;
  flex-direction: column;
}
.tab-content {
  flex: 1;
  overflow-y: auto; /* Make the tab content scrollable */
}
</style>
